import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	enableFinancingServices: true,
	useStaticPriceDateRemark: true,
	financeDomain: 'AUDI.SE',
	summaryFooterCta: {
		description: 'Beställ via Audi Partner',
		icon: 'send ',
		labelText: 'Beställ via Audi Partner',
		target: '_blank',

		trackingName: 'contact',
		url: ' https://www.audi.se/se/web/sv/forms/config-partner.html?modell={{carlineId}}',
	},
	financingDisclaimer: ['globalDisclaimer'],
};
